(() => {
  const initContactPage = (root) => {
    if (root.dataset.initialized) return;

    const form = root.querySelector('[data-contact-page-form]');
    const input = root.querySelector('[data-contact-captcha-input]');
    const code = root.querySelector('[data-contact-captcha-code]');
    const refresh = root.querySelector('[data-contact-captcha-refresh]');
    const error = root.querySelector('[data-contact-captcha-error]');
    if (!form || !input || !code) return;

    root.dataset.initialized = 'true';
    let expected = '';

    const generate = () => {
      expected = String(Math.floor(1000 + Math.random() * 9000));
      code.textContent = expected;
      input.value = '';
      input.removeAttribute('aria-invalid');
      if (error) error.hidden = true;
    };

    refresh?.addEventListener('click', () => {
      generate();
      input.focus();
    });
    input.addEventListener('input', () => {
      input.removeAttribute('aria-invalid');
      if (error) error.hidden = true;
    });
    form.addEventListener('submit', (event) => {
      if (input.value.trim() === expected) return;
      event.preventDefault();
      input.setAttribute('aria-invalid', 'true');
      if (error) error.hidden = false;
      input.focus();
    });

    generate();
  };

  const init = () => document.querySelectorAll('[data-contact-page]').forEach(initContactPage);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
